import React, { useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { NavList, NavItem } from 'components/composite';
import { TAB_MAP_ID } from 'constants/travelsafe';
import { Badge, Spacer, Row, Col, Card } from '@cleartrip/bento';

import { TabContext } from 'context/travelsafe/ae';
import Clevertap from 'analytics';
import { leavingUae } from 'pages/TravelSafe/ae/initialData';

import { ReactComponent as StaycationIcon } from 'assets/icons/staycations.svg';
import { ReactComponent as Mic } from 'assets/icons/mic.svg';
import { Divider } from '@cleartrip/bento/components/Divider';

function Tabs() {
	let query = new URLSearchParams(window.location.search);
	let history = useHistory();
	let [tab, setTab] = useContext(TabContext);

	let tabRef = useRef(null);
	let fromTabRef = useRef(null);
	let toTabRef = useRef(null);
	let visaTabRef = useRef(null);
	let staycationsTabRef = useRef(null);
	let podcastTabRef = useRef(null);

	useEffect(() => {
		let tabQuery = query.get('navtab');
		if (tabQuery) {
			setTab(tabQuery.toUpperCase());
			//for mobile
			let offsetLeft = fromTabRef.current.offsetLeft;
			if (window.innerWidth <= 1024) {
				if (tabQuery === TAB_MAP_ID.LEAVING_UAE) offsetLeft = fromTabRef.current.offsetLeft;
				if (tabQuery === TAB_MAP_ID.RETURNING_TO_UAE) offsetLeft = toTabRef.current.offsetLeft;
				if (tabQuery === TAB_MAP_ID.VISA_FAQ) offsetLeft = visaTabRef.current.offsetLeft;
				if (tabQuery === TAB_MAP_ID.STAYCATIONS) offsetLeft = staycationsTabRef.current.offsetLeft;
				if (tabQuery === TAB_MAP_ID.PODCASTS) offsetLeft = podcastTabRef.current.offsetLeft;
				tabRef.current.scrollLeft = offsetLeft - 20;
			}
		}
	}, [query, setTab]);

	function setTabHandler(tabId, eventName) {
		Clevertap.event('Air_UI_action', {
			action_name: 'navigation_topbar',
			action_value: eventName,
		});
		query.set('navtab', tabId);
		history.push({ search: '?' + query.toString() });
		setTab(tabId);
	}

	return (
		<>
			{/* <div className='d-none d-block--xs'> */}
				{/* <Row>
					<Col xs={24}>
						<Card
							className='flex br-4 bg-neutral-0 bc-neutral-100 ba p-4'
							onClick={() => setTabHandler(TAB_MAP_ID.STAYCATIONS, 'stay_cations')}
						>
							<StaycationIcon className='c-neutral-400' height={48} width={48} />
							<Spacer className='pr-3' />
							<div>
								<p className='fs-5 c-neutral-900'> Planning a staycation?</p>
								<Spacer className='pt-2' />
								<p className='fs-4 fw-500 c-secondary-500'>View safety guidelines</p>
							</div>
						</Card>
					</Col>
					<Spacer className='pt-2' />
					<Col xs={24}>
						<Card className='flex bg-neutral-0 br-4 bc-neutral-100 ba p-4' onClick={() => setTabHandler(TAB_MAP_ID.PODCASTS, 'podcasts')}>
							<Mic className='c-neutral-400' height={48} width={48} />
							<Spacer className='pr-3' />
							<div>
								<p className='fs-5 c-neutral-900 flex no-wrap flex-middle'>
									Listen to travel experts
									<Spacer className='mr-2' />
									<Badge style={{ marginTop: '2px' }} size='sm' type='success'>
										NEW
									</Badge>
								</p>
								<Spacer className='pt-2' />
								<p className='fs-4 hover:td-underline fw-500 c-secondary-500'>View podcasts</p>
							</div>
						</Card>
					</Col>
				</Row> */}
				{/* <Spacer className='pt-13' />
			</div> */}
			<Divider />
			<Spacer className="pt-3" />
			<NavList ref={tabRef}>
				{/* <NavItem
					active={tab === TAB_MAP_ID.LEAVING_UAE}
					className='fs-3 h-9 t-all h-7--xs'
					ref={fromTabRef}
					onClick={() => setTabHandler(TAB_MAP_ID.LEAVING_UAE, 'leaving_uae')}
				>
					Leaving UAE
				</NavItem> */}
				<NavItem
					active={tab === TAB_MAP_ID.TRAVEL_INFO}
					className='fs-3 h-9 t-all h-7--xs'
					ref={fromTabRef}
					onClick={() => setTabHandler(TAB_MAP_ID.TRAVEL_INFO, 'travel_info')}
				>
					Travel information
				</NavItem>
				<Spacer className="pr-10 pr-6--xs" />
				{/* <NavItem
					ref={toTabRef}
					active={tab === TAB_MAP_ID.RETURNING_TO_UAE}
					className='fs-3 h-9 t-all h-7--xs'
					onClick={() => setTabHandler(TAB_MAP_ID.RETURNING_TO_UAE, 'returning_to_uae')}
				>
					Returning to UAE
				</NavItem> */}
				<NavItem
					ref={visaTabRef}
					active={tab === TAB_MAP_ID.VISA_FAQ}
					className='fs-3 h-9 t-all h-7--xs'
					onClick={() => setTabHandler(TAB_MAP_ID.VISA_FAQ, 'visa_faq')}
				>
					UAE Visa
				</NavItem>
				<Spacer className="pr-10 pr-6--xs" />
				<NavItem
					active={tab === TAB_MAP_ID.STAYCATIONS}
					className='fs-3 h-9 t-all h-7--xs flex flex-start'
					onClick={() => setTabHandler(TAB_MAP_ID.STAYCATIONS, 'stay_cations')}
					ref={staycationsTabRef}
				>
					Staycations
				</NavItem>
				<Spacer className="pr-10 pr-6--xs" />
				<NavItem
					active={tab === TAB_MAP_ID.PODCASTS}
					className='fs-3 h-9 t-all h-7--xs flex flex-start'
					onClick={() => setTabHandler(TAB_MAP_ID.PODCASTS, 'podcasts')}
					ref={podcastTabRef}
				>
					Podcasts
					{/* <Spacer className='mr-2' />
					<Badge style={{ marginTop: '2px' }} size='sm' type='success'>
						NEW
					</Badge> */}
				</NavItem>
			</NavList>
		</>
	);
}

export default Tabs;
